import { apis } from '@/config';
import { api } from '@/api/api';
const Tag = '[Reminder]';
export class ReminderImpl {
    constructor() {
        this.name = apis.remindersImpl;
        this.http = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    afterInit() {
        if (process.env.BUILD_ISELECTRON && process.env.BUILD_ISEDM && this.systemApi.isMainPage()) {
            this.systemApi.intervalEvent({
                seq: 0,
                eventPeriod: 'mid',
                id: 'reminderx_notice_collector',
                handler: ev => {
                    console.log(Tag, 'schedule_notice_collector called');
                    if (ev.seq === 1 || ev.seq % 20 === 0) {
                        this.getReminders().then(data => {
                            if (data) {
                                this.systemApi.createWindowWithInitData('advertisingReminder', {
                                    eventName: 'customNotification',
                                    eventData: {
                                        eventType: 'advertisingReminder',
                                        reminders: [data],
                                    },
                                });
                            }
                        });
                    }
                },
            });
        }
        return this.name;
    }
    async getReminders() {
        const { data } = await this.http.get(this.systemApi.getUrl('getBusinessAds'));
        if ((data === null || data === void 0 ? void 0 : data.success) || (data === null || data === void 0 ? void 0 : data.code) === 200) {
            return data.data;
        }
        return Promise.reject(data.message);
    }
    async trackLog(adsId) {
        const url = this.systemApi.getUrl('setBusinessAdsClick');
        const res = await this.http.post(url, { id: adsId }, { contentType: 'json' });
        return Number(res === null || res === void 0 ? void 0 : res.code) === 200;
    }
}
const impl = new ReminderImpl();
api.registerLogicalApi(impl);
export default impl;
